import { type FC } from 'react'
import pluralize from 'pluralize'
import { type BulkInviteResult } from './bulkInviteResult'
import { requestedLine } from './bulkSummaryCopy'

export interface BulkInviteResultSummaryProps {
  result: BulkInviteResult
  canBuy: boolean
}

export const BulkInviteResultSummary: FC<BulkInviteResultSummaryProps> = ({ result, canBuy }) => (
  <div className='d-flex gap-2 align-items-start rounded-2 zocks-bg-color-gray-100 border zocks-border-color-gray-300 px-3 py-4'>
    <i className='bi bi-info-circle zocks-text-gray-600 flex-shrink-0' />
    <div className='d-flex flex-column gap-3 paragraph-small zocks-text-gray-600'>
      <div className='bold'>
        {result.sentCount} {pluralize('invitation', result.sentCount)} sent.
      </div>
      {result.requestedCount > 0 ? (
        <div>
          <div className='bold'>
            {result.requestedCount} {pluralize('invitation', result.requestedCount)} went to the requested list.
          </div>
          <div>{requestedLine(canBuy, result.requestedCount)}</div>
        </div>
      ) : null}
      {result.notAcceptedCount > 0 ? (
        <div className='bold'>
          {result.notAcceptedCount} {pluralize('row', result.notAcceptedCount)} {result.notAcceptedCount === 1 ? 'was' : 'were'} not accepted.
        </div>
      ) : null}
    </div>
  </div>
)
